  (function () {
    'use strict';

    const CONFIG = {
      agentName: window.PRESTIGE_CHAT_NAME || 'ARIA',
      agentAvatar: window.PRESTIGE_CHAT_AVATAR || '',
      welcomeMessage: window.PRESTIGE_CHAT_WELCOME || 'Bienvenue. Que recherchez-vous ?',
      groqKey: window.PRESTIGE_CHAT_GROQKEY || '',
      groqModel: 'llama-3.3-70b-versatile',
      shopDomain: window.PRESTIGE_CHAT_DOMAIN || '',
      storefrontToken: window.PRESTIGE_CHAT_SFTOKEN || '',
      storeUrl: (window.PRESTIGE_CHAT_STORE_URL || window.location.origin).replace(/\/$/, ''),
      systemPrompt: window.PRESTIGE_CHAT_SYSTEM || 'Tu es un assistant e-commerce français.',
      apiVersion: '2026-07',
      maxProducts: 3,
    };

    const EFFECTS = {
      Marbre: ['marbre', 'marbre', 'calacatta', 'carrara', 'statuario', 'marquina'],
      Ciment: ['ciment', 'beton', 'beton cire', 'industriel'],
      Stone: ['stone', 'pierre', 'pierre naturelle', 'mineral'],
      Bois: ['bois', 'parquet', 'chene', 'lame de bois'],
      Faillance: ['faillance', 'faience', 'carreau mural', 'carrelage mural'],
    };
    const COLORS = {
      Bleu: ['bleu', 'marine', 'azur', 'turquoise'],
      Noir: ['noir'], Blanc: ['blanc', 'ivoire'], Beige: ['beige', 'sable', 'creme'],
      Vert: ['vert', 'olive', 'sauge', 'kaki'], Violet: ['violet', 'mauve', 'lilas'],
      Marron: ['marron', 'brun', 'chocolat'], Orange: ['orange', 'terracotta', 'cuivre'],
      Taupe: ['taupe', 'grege', 'greige'], Jaune: ['jaune', 'moutarde', 'ocre'],
      Gris: ['gris', 'anthracite', 'argent'], Rouge: ['rouge', 'bordeaux'],
      Rose: ['rose', 'poudre', 'vieux rose'],
    };
    const FINISHES = {
      mat: ['mat', 'matt', 'matte'],
      brillant: ['brillant', 'glossy', 'gloss'],
      satin: ['satin', 'satine'],
      poli: ['poli', 'polished', 'luc', 'lux'],
      structure: ['structure', 'structuree', 'relief'],
      antiderapant: ['antiderapant', 'grip'],
      naturel: ['naturel', 'natural'],
      lappato: ['lappato'],
    };
    const EFFECT_COLLECTIONS = {
      Marbre: 'carrelage-effet-marbre',
      Ciment: 'carrelage-effet-ciment',
      Stone: 'carrelage-effet-pierre',
      Bois: 'carrelage-effet-bois',
      Faillance: 'faillance',
    };
    const CATALOG_COLLECTIONS = {
      'revetement-3d': { label: 'revêtements muraux 3D', handles: ['revetement-3d'], words: ['panneau 3d', 'panneaux 3d', 'panneau mural 3d', 'revetement 3d', 'mur 3d'] },
      plinthes: { label: 'plinthes', handles: ['plinthes'], words: ['plinthe', 'plinthes'] },
      corniches: { label: 'corniches', handles: ['corniches'], words: ['corniche', 'corniches'] },
      cimaises: { label: 'cimaises', handles: ['cimaise'], words: ['cimaise', 'cimaises'] },
      'eclairage-indirect': { label: 'éclairage indirect', handles: ['eclairage-indirect'], words: ['eclairage indirect', 'corniche lumineuse'] },
      'elements-decoratifs': { label: 'éléments décoratifs', handles: ['elements-decoratifs'], words: ['element decoratif', 'elements decoratifs', 'rosace', 'colonne decorative'] },
      'colles-et-outils': { label: 'colles et outils', handles: ['colles-et-outils'], words: ['colle', 'colles', 'outil', 'outils'] },
      tapisserie: { label: 'tapisseries et papiers peints', handles: ['arte-wall'], words: ['tapisserie', 'papier peint', 'papiers peints', 'revetement mural'] },
      moulures: { label: 'moulures', handles: ['plinthes', 'corniches', 'cimaise', 'revetement-3d', 'elements-decoratifs'], words: ['moulure', 'moulures', 'moulure 3d', 'moulures 3d'] },
    };

    const CSS = `
      @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500&family=Outfit:wght@300;400;500&display=swap');
      #prestige-chat-fab{position:fixed;bottom:28px;right:28px;width:58px;height:58px;background:#0d0d0d;border:1px solid #2a2a2a;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:9998;box-shadow:0 8px 40px rgba(0,0,0,.5)}
      #prestige-chat-fab:hover{transform:scale(1.06)}#prestige-chat-fab svg{width:24px;height:24px;fill:none;stroke:#ccc;stroke-width:1.8}
      #prestige-chat-badge{position:absolute;top:-2px;right:-2px;width:16px;height:16px;background:#e0e0e0;border-radius:50%;border:2px solid #0d0d0d;display:none;font-size:9px;color:#111;align-items:center;justify-content:center}.visible#prestige-chat-badge{display:flex}
      #prestige-chat-widget{position:fixed;bottom:100px;right:28px;width:400px;max-width:calc(100vw - 40px);background:#111;border:1px solid #1e1e1e;border-radius:20px;overflow:hidden;z-index:9999;box-shadow:0 20px 80px rgba(0,0,0,.7);font-family:'Outfit',sans-serif;display:none;flex-direction:column}#prestige-chat-widget.open{display:flex}
      .pchat-header{background:#0d0d0d;border-bottom:1px solid #1a1a1a;padding:16px 18px;display:flex;align-items:center;gap:12px}.pchat-avatar,.pchat-msg-av{border-radius:50%;overflow:hidden;background:#1a1a1a;display:flex;align-items:center;justify-content:center}.pchat-avatar{width:44px;height:44px}.pchat-avatar img,.pchat-msg-av img{width:100%;height:100%;object-fit:cover}.pchat-info{flex:1}.pchat-name{font-family:'Space Grotesk';font-size:15px;color:#eee}.pchat-subtitle{font-size:11px;color:#555;letter-spacing:2px;text-transform:uppercase}.pchat-close-btn{border:1px solid #222;background:transparent;color:#777;border-radius:8px;width:30px;height:30px;cursor:pointer}
      .pchat-messages{overflow-y:auto;padding:20px 16px;display:flex;flex-direction:column;gap:18px;max-height:400px;min-height:240px}.pchat-msg{display:flex;gap:9px;align-items:flex-end}.pchat-msg.user{flex-direction:row-reverse}.pchat-msg-av{width:26px;height:26px;flex:none;font-size:10px;color:#777}.pchat-bubble{max-width:290px;padding:11px 14px;border-radius:16px;font-size:13.5px;line-height:1.6}.pchat-msg.bot .pchat-bubble{background:#161616;border:1px solid #222;color:#c0c0c0}.pchat-msg.user .pchat-bubble{background:#eee;color:#111}.pchat-bubble a{color:#fff;text-decoration:underline;text-underline-offset:3px}.pchat-time{font-size:10px;color:#444;margin-top:5px}.pchat-msg.user .pchat-time{text-align:right}
      .pchat-typing{display:flex;gap:5px;padding:13px 14px;background:#161616;border:1px solid #222;border-radius:16px}.pchat-dot{width:5px;height:5px;background:#777;border-radius:50%;animation:pchat-bounce 1.4s infinite}.pchat-dot:nth-child(2){animation-delay:.2s}.pchat-dot:nth-child(3){animation-delay:.4s}@keyframes pchat-bounce{0%,60%,100%{transform:translateY(0);opacity:.4}30%{transform:translateY(-5px);opacity:1}}
      .pchat-suggestions{padding:0 16px 14px;display:flex;gap:7px;flex-wrap:wrap}.pchat-chip{font-size:11.5px;padding:5px 12px;border-radius:20px;border:1px solid #222;background:#161616;color:#777;cursor:pointer}.pchat-input-area{border-top:1px solid #191919;padding:14px 16px;background:#0d0d0d;display:flex;gap:9px}.pchat-input{flex:1;background:#161616;border:1px solid #222;border-radius:11px;padding:10px 14px;color:#ddd;font:13.5px 'Outfit';outline:none}.pchat-send{width:38px;height:38px;border-radius:11px;background:#e8e8e8;border:0;cursor:pointer}.pchat-send:disabled{opacity:.35}
      @media(max-width:480px){#prestige-chat-widget{right:16px;bottom:88px;width:calc(100vw - 32px)}#prestige-chat-fab{right:16px;bottom:20px}}
    `;

    let isOpen = false;
    let isLoading = false;
    let unreadCount = 0;
    const conversationHistory = [];
    let lastSearchCriteria = null;
    let currentCollectionLink = null;
    const shownProductHandles = new Set();

    function normalize(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/,/g, '.').replace(/[^a-z0-9.]+/g, ' ').trim();
    }

    function findDictionaryMatch(text, dictionary) {
      const normalized = ` ${normalize(text)} `;
      for (const [tag, words] of Object.entries(dictionary)) {
        if (words.some(word => normalized.includes(` ${normalize(word)} `))) return tag;
      }
      return null;
    }

    function findDictionaryMatches(text, dictionary) {
      const normalized = ` ${normalize(text)} `;
      return Object.entries(dictionary)
        .filter(([, words]) => words.some(word => normalized.includes(` ${normalize(word)} `)))
        .map(([tag]) => tag);
    }

    function detectCatalogCollection(message) {
      const text = normalize(message);
      for (const [key, collection] of Object.entries(CATALOG_COLLECTIONS)) {
        if (collection.words.some(word => text.includes(normalize(word)))) return key;
      }
      return null;
    }

    function extractCriteria(message) {
      const text = normalize(message);
      const formatMatch = text.match(/(\d+(?:\.\d+)?)\s*(?:x|×)\s*(\d+(?:\.\d+)?)/i);
      const thicknessMatch = text.match(/(\d+(?:\.\d+)?)\s*mm\b/i);
      return {
        effect: findDictionaryMatch(message, EFFECTS),
        colors: findDictionaryMatches(message, COLORS),
        colorMode: /\bou\b/.test(text) ? 'any' : 'all',
        format: formatMatch ? [Number(formatMatch[1]), Number(formatMatch[2])] : null,
        thickness: thicknessMatch ? Number(thicknessMatch[1]) : null,
        finish: findDictionaryMatch(message, FINISHES),
        collectionKey: detectCatalogCollection(message),
      };
    }

    function sameFormat(text, expected) {
      if (!expected) return true;
      const match = normalize(text).match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/);
      if (!match) return false;
      const actual = [Number(match[1]), Number(match[2])].sort((a, b) => a - b);
      const wanted = [...expected].sort((a, b) => a - b);
      return Math.abs(actual[0] - wanted[0]) < 0.01 && Math.abs(actual[1] - wanted[1]) < 0.01;
    }

    function variantMatches(variant, criteria) {
      const selectedOptions = Array.isArray(variant.selectedOptions)
        ? variant.selectedOptions.map(option => `${option.name} ${option.value}`)
        : [variant.option1, variant.option2, variant.option3].filter(Boolean);
      const optionsText = selectedOptions.join(' ');
      const normalized = normalize(`${variant.title} ${optionsText}`);
      if (criteria.format && !sameFormat(normalized, criteria.format)) return false;
      if (criteria.finish && !FINISHES[criteria.finish].some(value => normalized.includes(normalize(value)))) return false;
      if (criteria.thickness && !normalized.includes(normalize(`${criteria.thickness} mm`))) return false;
      return true;
    }

    function productMatchesTags(product, criteria) {
      if (criteria.collectionKey) return true;
      const tags = (product.tags || []).map(normalize);
      if (criteria.effect && !tags.includes(normalize(criteria.effect))) return false;
      if (criteria.colors.length) {
        const matches = criteria.colors.map(color => tags.includes(normalize(color)));
        if (criteria.colorMode === 'any' && !matches.some(Boolean)) return false;
        if (criteria.colorMode === 'all' && !matches.every(Boolean)) return false;
      }
      return true;
    }

    function isMoreProductsRequest(message) {
      const text = normalize(message);
      return /\b(autre|autres|encore|davantage)\b/.test(text) || text.includes('plus de choix') || text.includes('plus de produits');
    }

    function shouldSearchCatalog(message) {
      if (isMoreProductsRequest(message) && lastSearchCriteria) return true;
      const criteria = extractCriteria(message);
      if (hasStructuredCriteria(criteria)) return true;
      const text = normalize(message);
      const productWords = [
        'carrelage', 'carreau', 'faience', 'moulure', 'corniche', 'cimaise', 'plinthe',
        'panneau 3d', 'papier peint', 'tapisserie', 'revetement mural', 'robinetterie',
        'mitigeur', 'robinet', 'douche', 'vasque', 'produit', 'collection', 'reference',
        'format', 'finition', 'epaisseur', 'couleur', 'effet', 'sku',
      ];
      const searchWords = ['je cherche', 'recherche', 'montre moi', 'propose', 'recommande', 'avez vous'];
      return productWords.some(word => text.includes(normalize(word))) || searchWords.some(word => text.includes(normalize(word)));
    }

    function hasStructuredCriteria(criteria) {
      return Boolean(criteria.effect || criteria.colors.length || criteria.format || criteria.thickness || criteria.finish || criteria.collectionKey);
    }

    function mergeCriteria(previous, current) {
      return {
        effect: current.effect || previous.effect,
        colors: current.colors.length ? current.colors : previous.colors,
        colorMode: current.colors.length ? current.colorMode : previous.colorMode,
        format: current.format || previous.format,
        thickness: current.thickness || previous.thickness,
        finish: current.finish || previous.finish,
        collectionKey: current.collectionKey || previous.collectionKey,
      };
    }

    function buildCollectionLink(criteria) {
      if (criteria.collectionKey) {
        const collection = CATALOG_COLLECTIONS[criteria.collectionKey];
        if (!collection || collection.handles.length !== 1) return null;
        return {
          label: `Voir toute la collection ${collection.label}`,
          url: `${CONFIG.storeUrl}/collections/${collection.handles[0]}`,
        };
      }
      if (!criteria.effect || !EFFECT_COLLECTIONS[criteria.effect]) return null;
      const params = new URLSearchParams();
      criteria.colors.forEach(color => params.append('filter.p.m.custom.couleurs', color));
      const query = params.toString();
      const effectLabel = criteria.effect === 'Stone' ? 'pierre' : criteria.effect === 'Faillance' ? 'faïence' : criteria.effect.toLowerCase();
      const colorsLabel = criteria.colors.length ? ` ${criteria.colors.join(' et ').toLowerCase()}` : '';
      return {
        label: `Voir toute la collection effet ${effectLabel}${colorsLabel}`,
        url: `${CONFIG.storeUrl}/collections/${EFFECT_COLLECTIONS[criteria.effect]}${query ? `?${query}` : ''}`,
      };
    }

    async function fetchJson(url) {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Catalogue HTTP ${response.status}`);
      return response.json();
    }

    async function fetchCollectionProducts(handle) {
      const products = [];
      for (let page = 1; page <= 3; page++) {
        const payload = await fetchJson(`${window.location.origin}/collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`);
        const batch = payload.products || [];
        products.push(...batch);
        if (batch.length < 250) break;
      }
      return products;
    }

    async function fetchSuggestedProducts(message) {
      const url = `${window.location.origin}/search/suggest.json?q=${encodeURIComponent(message)}&resources[type]=product&resources[limit]=10`;
      const payload = await fetchJson(url);
      const suggestions = payload.resources?.results?.products || [];
      const handles = suggestions.map(product => product.handle || String(product.url || '').split('/products/')[1]?.split('?')[0]).filter(Boolean);
      return Promise.all(handles.map(handle => fetchJson(`${window.location.origin}/products/${encodeURIComponent(handle)}.js`)));
    }

    function getPrice(variant) {
      const raw = variant.price?.amount ?? variant.price;
      if (raw === null || raw === undefined || raw === '') return null;
      const amount = typeof raw === 'number' ? raw / 100 : Number(raw);
      if (!Number.isFinite(amount) || amount <= 0) return null;
      const currency = variant.price?.currencyCode || 'EUR';
      return `${amount.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;
    }

    async function searchShopify(message) {
      const extractedCriteria = extractCriteria(message);
      const continuation = isMoreProductsRequest(message) && lastSearchCriteria;
      const criteria = continuation ? mergeCriteria(lastSearchCriteria, extractedCriteria) : extractedCriteria;

      if (!continuation) shownProductHandles.clear();
      if (hasStructuredCriteria(criteria)) lastSearchCriteria = { ...criteria, colors: [...criteria.colors] };
      currentCollectionLink = buildCollectionLink(criteria);

      let products;
      if (criteria.collectionKey && CATALOG_COLLECTIONS[criteria.collectionKey]) {
        const batches = await Promise.all(CATALOG_COLLECTIONS[criteria.collectionKey].handles.map(fetchCollectionProducts));
        const interleaved = [];
        const longestBatch = Math.max(0, ...batches.map(batch => batch.length));
        for (let index = 0; index < longestBatch; index++) {
          batches.forEach(batch => { if (batch[index]) interleaved.push(batch[index]); });
        }
        const unique = new Map(interleaved.map(product => [product.handle, product]));
        products = [...unique.values()];
      } else if (criteria.effect && EFFECT_COLLECTIONS[criteria.effect]) {
        products = await fetchCollectionProducts(EFFECT_COLLECTIONS[criteria.effect]);
      } else if (criteria.colors.length) {
        products = await fetchCollectionProducts(normalize(criteria.colors[0]));
      } else {
        products = await fetchSuggestedProducts(message);
      }

      const results = products.filter(product => productMatchesTags(product, criteria)).map(product => {
        const productVariants = product.variants?.nodes || product.variants || [];
        const variants = productVariants.filter(variant => variantMatches(variant, criteria));
        const hasVariantCriteria = Boolean(criteria.format || criteria.finish || criteria.thickness);
        const chosen = variants.find(variant => variant.availableForSale ?? variant.available) || variants[0];
        if (hasVariantCriteria && !chosen) return null;
        const url = hasVariantCriteria && chosen
          ? `${CONFIG.storeUrl}/products/${product.handle}?variant=${String(chosen.id).split('/').pop()}`
          : `${CONFIG.storeUrl}/products/${product.handle}`;
        return {
          handle: product.handle,
          title: product.title,
          tags: product.tags || [],
          available: chosen ? (chosen.availableForSale ?? chosen.available) : (product.availableForSale ?? product.available),
          variant: chosen?.title || null,
          price: chosen ? getPrice(chosen) : null,
          description: String(product.body_html || product.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 350),
          url,
        };
      }).filter(Boolean).filter(product => !continuation || !shownProductHandles.has(product.handle)).slice(0, CONFIG.maxProducts);

      results.forEach(product => shownProductHandles.add(product.handle));
      return results;
    }

    function buildCatalogContext(products, catalogError = null) {
      if (catalogError) {
        return `CATALOGUE SHOPIFY : la recherche catalogue est temporairement indisponible (${catalogError}). Ne prétends pas qu'aucun produit n'existe. Réponds au conseil général et indique seulement que tu ne peux pas afficher les références pour le moment.`;
      }
      if (!products.length) {
        return 'CATALOGUE SHOPIFY : aucun produit correspondant exactement aux critères détectés. Ne propose aucun produit inventé.';
      }
      const lines = products.map((product, index) => {
        const details = [
          product.variant ? `variante : ${product.variant}` : null,
          product.price ? `prix : ${product.price}` : null,
          `disponible : ${product.available ? 'oui' : 'non'}`,
          `tags : ${product.tags.join(', ')}`,
          product.description ? `description : ${product.description}` : null,
        ].filter(Boolean).join(' ; ');
        return `${index + 1}. ${product.title} — ${details} — lien obligatoire : [${product.title}](${product.url})`;
      });
      const collectionLine = currentCollectionLink
        ? `\nLIEN DE COLLECTION FILTRÉE À AJOUTER APRÈS LES PRODUITS : [${currentCollectionLink.label}](${currentCollectionLink.url})`
        : '';
      return `CATALOGUE SHOPIFY TROUVÉ POUR LA DERNIÈRE DEMANDE :\n${lines.join('\n')}${collectionLine}\nUtilise uniquement ces résultats et conserve exactement les liens Markdown fournis.`;
    }

    function buildWidget() {
      const style = document.createElement('style'); style.textContent = CSS; document.head.appendChild(style);
      const fab = document.createElement('div'); fab.id = 'prestige-chat-fab'; fab.setAttribute('role', 'button'); fab.innerHTML = '<svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg><div id="prestige-chat-badge"></div>'; document.body.appendChild(fab);
      const avatar = CONFIG.agentAvatar ? `<img src="${escapeAttr(CONFIG.agentAvatar)}" alt="${escapeAttr(CONFIG.agentName)}">` : '✦';
      const widget = document.createElement('div'); widget.id = 'prestige-chat-widget'; widget.innerHTML = `
        <div class="pchat-header"><div class="pchat-avatar">${avatar}</div><div class="pchat-info"><div class="pchat-name">${escapeHTML(CONFIG.agentName)}</div><div class="pchat-subtitle">En ligne · IA Prestige</div></div><button class="pchat-close-btn" id="pchat-close">×</button></div>
        <div class="pchat-messages" id="pchat-msgs" role="log" aria-live="polite"></div>
        <div class="pchat-suggestions" id="pchat-chips"><button class="pchat-chip" data-msg="Je cherche un carrelage effet pierre beige">Carrelage</button><button class="pchat-chip" data-msg="Je cherche des moulures murales">Moulures</button><button class="pchat-chip" data-msg="Je cherche un papier peint">Papier peint</button></div>
        <div class="pchat-input-area"><input class="pchat-input" id="pchat-input" placeholder="Écrivez votre message…"><button class="pchat-send" id="pchat-send">↑</button></div>`;
      document.body.appendChild(widget);
      fab.addEventListener('click', toggleChat); document.getElementById('pchat-close').addEventListener('click', toggleChat); document.getElementById('pchat-send').addEventListener('click', handleSend);
      document.getElementById('pchat-input').addEventListener('keydown', event => { if (event.key === 'Enter') handleSend(); });
      document.querySelectorAll('.pchat-chip').forEach(chip => chip.addEventListener('click', () => sendUserMessage(chip.dataset.msg)));
      appendMessage('bot', CONFIG.welcomeMessage);
    }

    function toggleChat() { isOpen = !isOpen; document.getElementById('prestige-chat-widget').classList.toggle('open', isOpen); if (isOpen) { unreadCount = 0; updateBadge(); } }
    function updateBadge() { const badge = document.getElementById('prestige-chat-badge'); if (!badge) return; badge.textContent = unreadCount; badge.classList.toggle('visible', !isOpen && unreadCount > 0); }
    function nowTime() { return new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }); }

    function appendMessage(type, text) {
      const area = document.getElementById('pchat-msgs');
      const row = document.createElement('div'); row.className = `pchat-msg ${type}`;
      const avatar = type === 'bot' && CONFIG.agentAvatar ? `<img src="${escapeAttr(CONFIG.agentAvatar)}" alt="">` : (type === 'bot' ? '✦' : 'U');
      row.innerHTML = `<div class="pchat-msg-av">${avatar}</div><div><div class="pchat-bubble"></div><div class="pchat-time">${nowTime()}</div></div>`;
      renderText(row.querySelector('.pchat-bubble'), text);
      area.appendChild(row); area.scrollTop = area.scrollHeight;
      if (type === 'bot' && !isOpen) { unreadCount++; updateBadge(); }
    }

    function renderText(container, text) {
      const pattern = /\[([^\]]+)]\((https?:\/\/[^\s)]+)\)/g;
      let cursor = 0; let match;
      while ((match = pattern.exec(text)) !== null) {
        container.append(document.createTextNode(text.slice(cursor, match.index)));
        const link = document.createElement('a'); link.textContent = match[1]; link.href = match[2]; link.target = '_blank'; link.rel = 'noopener'; container.append(link);
        cursor = pattern.lastIndex;
      }
      container.append(document.createTextNode(text.slice(cursor)));
      container.innerHTML = container.innerHTML.replace(/\n/g, '<br>');
    }

    function showTyping() { const area = document.getElementById('pchat-msgs'); const row = document.createElement('div'); row.className = 'pchat-msg bot'; row.id = 'pchat-typing-row'; row.innerHTML = '<div class="pchat-msg-av">✦</div><div class="pchat-typing"><i class="pchat-dot"></i><i class="pchat-dot"></i><i class="pchat-dot"></i></div>'; area.appendChild(row); area.scrollTop = area.scrollHeight; }
    function hideTyping() { document.getElementById('pchat-typing-row')?.remove(); }
    async function handleSend() { const input = document.getElementById('pchat-input'); const text = input.value.trim(); if (!text || isLoading) return; input.value = ''; await sendUserMessage(text); }

    async function sendUserMessage(text) {
      if (isLoading) return;
      document.getElementById('pchat-chips').style.display = 'none'; appendMessage('user', text); conversationHistory.push({ role: 'user', content: text });
      isLoading = true; document.getElementById('pchat-send').disabled = true; showTyping();
      try {
        let products = [];
        let catalogError = null;
        let catalogContext = null;
        if (shouldSearchCatalog(text)) {
          try { products = await searchShopify(text); } catch (error) { catalogError = error.message; console.warn('[ARIA Shopify]', error); }
          catalogContext = buildCatalogContext(products, catalogError);
        }
        const reply = await callGroq(catalogContext);
        hideTyping(); appendMessage('bot', reply); conversationHistory.push({ role: 'assistant', content: reply });
      } catch (error) { hideTyping(); appendMessage('bot', 'Une erreur est survenue. Veuillez réessayer dans un instant.'); console.error('[ARIA]', error); }
      finally { isLoading = false; document.getElementById('pchat-send').disabled = false; }
    }

    async function callGroq(catalogContext) {
      const previousMessages = conversationHistory.slice(0, -1);
      const latestMessage = conversationHistory[conversationHistory.length - 1];
      const messages = [
        { role: 'system', content: CONFIG.systemPrompt },
        ...previousMessages,
        { role: 'user', content: catalogContext ? `${latestMessage?.content || ''}\n\n${catalogContext}` : (latestMessage?.content || '') },
      ];
      const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${CONFIG.groqKey}` },
        body: JSON.stringify({ model: CONFIG.groqModel, max_tokens: 512, temperature: 0.2, messages }),
      });
      if (!response.ok) { const error = await response.json().catch(() => ({})); throw new Error(error.error?.message || `Groq HTTP ${response.status}`); }
      const data = await response.json(); return data.choices?.[0]?.message?.content || "Je n'ai pas pu générer une réponse.";
    }

    function escapeHTML(value) { return String(value).replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]); }
    function escapeAttr(value) { return escapeHTML(value); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildWidget); else buildWidget();
  })();
